import { WebApiService } from './plugins/webApiService';
import ConfigurationSecretWsController from './scheduler/manager/serverless/admin-api/ws-controllers/ConfigurationSecretWsController';
import ContainerWsController from './scheduler/manager/serverless/admin-api/ws-controllers/ContainerWsController';
import DashboardWsController from './scheduler/manager/serverless/admin-api/ws-controllers/DashboardWsController';
import DockerRegistryWsController from './scheduler/manager/serverless/admin-api/ws-controllers/DockerRegistryWsController';
import GitWsController from './scheduler/manager/serverless/admin-api/ws-controllers/GitWsController';
import JobConfigurationWsController from './scheduler/manager/serverless/admin-api/ws-controllers/JobConfigurationWsController';
import JobFolderWsController from './scheduler/manager/serverless/admin-api/ws-controllers/JobFolderWsController';
import JobWsController from './scheduler/manager/serverless/admin-api/ws-controllers/JobWsController';
import TagWsController from './scheduler/manager/serverless/admin-api/ws-controllers/TagWsController';
import ArgoCDSettingsWsController from './scheduler/manager/serverless/admin-api/ws-controllers/settings/ArgoCDSettingsWsController';
import DevOpsSettingsWsController from './scheduler/manager/serverless/admin-api/ws-controllers/settings/DevOpsSettingsWsController';
import GitAccessWsController from './scheduler/manager/serverless/admin-api/ws-controllers/settings/GitAccessWsController'

export default class apiDataSourceSchedulerAdmin {
	ConfigurationSecretWsController: ConfigurationSecretWsController;
	ContainerWsController: ContainerWsController;
	DashboardWsController: DashboardWsController;
	DockerRegistryWsController: DockerRegistryWsController;
	GitWsController: GitWsController;
	JobConfigurationWsController: JobConfigurationWsController;
	JobFolderWsController: JobFolderWsController;
	JobWsController: JobWsController;
	TagWsController: TagWsController;
	ArgoCDSettingsWsController: ArgoCDSettingsWsController;
	DevOpsSettingsWsController: DevOpsSettingsWsController;
	GitAccessWsController: GitAccessWsController;
	constructor(cookieName?: string) {
		this.ConfigurationSecretWsController = new ConfigurationSecretWsController(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ContainerWsController = new ContainerWsController(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.DashboardWsController = new DashboardWsController(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.DockerRegistryWsController = new DockerRegistryWsController(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.GitWsController = new GitWsController(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.JobConfigurationWsController = new JobConfigurationWsController(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.JobFolderWsController = new JobFolderWsController(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.JobWsController = new JobWsController(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TagWsController = new TagWsController(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ArgoCDSettingsWsController = new ArgoCDSettingsWsController(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.DevOpsSettingsWsController = new DevOpsSettingsWsController(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.GitAccessWsController = new GitAccessWsController(undefined, cookieName, "appWebSettings.json", "apiUrl");
	}

}
